export const Constants = {
	daysOfWeek: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
	daysOfWeekPtbr: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado", "domingo"],

	monthsPtbr: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],

	flagIcons: {
		'pt': 'flag-br.webp', // brazil
		'en': 'flag-us.jpeg', // usa
		'cn': 'flag-cn.png', // china
		'de': 'flag-de.gif', // germany
		'es': 'flag-es.webp', // spain
		'jp': 'flag-jp.webp', // japan
		'fr': 'flag-fr.webp', // france
		'ru': 'flag-ru.png', // russia
		'it': 'flag-it.png' // italy
	}
}